/**
 * TimelineEmptyState — Empty state corporativo para histórico sem eventos.
 */
import React from 'react';
import { History } from 'lucide-react';

export const TimelineEmptyState: React.FC = () => (
  <div className="flex flex-col items-center justify-center gap-2 px-4 py-10 text-center">
    <div className="flex h-10 w-10 items-center justify-center rounded-full bg-slate-100 dark:bg-slate-800">
      <History size={18} className="text-slate-400" />
    </div>
    <p className="text-[12px] font-semibold text-slate-700 dark:text-slate-200">
      Nenhum evento registrado
    </p>
    <p className="max-w-[220px] text-[11px] leading-relaxed text-slate-500 dark:text-slate-400">
      A execução ainda não possui movimentações. A primeira ação registrada aparecerá aqui.
    </p>
  </div>
);

export default TimelineEmptyState;
